export const SEND_BUTTON_PROPS = {
  id: 'send-confirmation-send',
  icon: 'send',
  label: 'Send',
  size: 40,
  left: true,
};
